import { REPS_URL } from "../constants";
import { apiSlice } from "./apiSlice";



export const repsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getReps: builder.query({
            query: () => ({
                url: REPS_URL,
            }),
            keepUnusedDataFor:5
        }),
        createRep: builder.mutation({
            query: (data) => ({
                url: REPS_URL,
                method: 'POST',
                body: data,
            }),
            invalidatesTags:['Reps']
        }),
        updateRep: builder.mutation({
            query: (data) => ({
                url: `${REPS_URL}/${data._id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags:['Reps']
        }),
        deleteRep: builder.mutation({
            query: (repId) => ({
                url: `${REPS_URL}/${repId}`,
                method: 'DELETE',
            }),
        }),
    })
});

export const {useGetRepsQuery, useCreateRepMutation, useUpdateRepMutation, useDeleteRepMutation} = repsApiSlice;